{
  "sectionId": "config_data",
  "header": "Config",
  "available_actions": null,
  "attributes": [
    {
      "attribute_ID": "module",
      "fieldName": "module",
      "label": "Module",
      "type": "select",
      "mandatory": "Y",
      "validator": null,
      "tooltip": "Please select a module",
      "isAvailable": "Y",
      "placeholder": "Select Module"
    },
    {
      "attribute_ID": "category",
      "fieldName": "category",
      "label": "Category",
      "type": "select",
      "mandatory": "N",
      "validator": null,
      "tooltip": "Please select a category",
      "isAvailable": "Y",
      "placeholder": "Select Category"
    },
    {
      "attribute_ID": "subCategory",
      "fieldName": "subCategory",
      "label": "Sub Category",
      "type": "input",
      "mandatory": "N",
      "validator": null,
      "tooltip": "Please enter a sub category",
      "isAvailable": "Y",
      "placeholder": "Sub Category"
    },
    {
      "attribute_ID": "orgType",
      "fieldName": "orgType",
      "label": "Org Type",
      "type": "select",
      "mandatory": "N",
      "validator": null,
      "tooltip": "Please select an organization type",
      "isAvailable": "Y",
      "placeholder": "Select Org Type"
    },
    {
      "attribute_ID": "orgName",
      "fieldName": "orgName",
      "label": "Org Name",
      "type": "select",
      "mandatory": "N",
      "validator": null,
      "tooltip": "Please select an organization name",
      "isAvailable": "Y",
      "placeholder": "Select Org Name"
    },
    {
      "attribute_ID": "configKey",
      "fieldName": "configKey",
      "label": "Key",
      "type": "text",
      "mandatory": "Y",
      "validator": null,
      "tooltip": "Please enter a key",
      "isAvailable": "Y",
      "placeholder": "Key"
    },
    {
      "attribute_ID": "configValue",
      "fieldName": "configValue",
      "label": "Value",
      "type": "text",
      "mandatory": "Y",
      "validator": null,
      "tooltip": "Please enter a value",
      "isAvailable": "Y",
      "placeholder": "Value"
    },
    {
      "attribute_ID": "configDesc",
      "fieldName": "configDesc",
      "label": "Description",
      "type": "text",
      "mandatory": "N",
      "validator": null,
      "tooltip": "Please add a description (optional)",
      "isAvailable": "Y",
      "placeholder": "Description"
    },
    {
      "attribute_ID": "isActive",
      "fieldName": "isActive",
      "label": "Active",
      "type": "radio",
      "mandatory": "N",
      "validator": null,
      "tooltip": "Please select a value",
      "isAvailable": "Y"
    }
  ],
  "validations": [
    {
      "whatToCheck": "atLeastXEntered",
      "clientOrServer": "C",
      "attributes": [
        {
          "validatorid": 1,
          "attribute_ID": ["module"],
          "functionParams": {
            "ErrMsg": "Please select a module"
          }
        },
        {
          "validatorid": 2,
          "attribute_ID": ["configKey"],
          "functionParams": {
            "ErrMsg": "Please enter a key"
          }
        },
        {
          "validatorid": 3,
          "attribute_ID": ["configValue"],
          "functionParams": {
            "ErrMsg": "Please enter a value"
          }
        }
      ]
    }
  ],
  "actions": [
    {
      "Name": "Previous",
      "Validate": null
    },
    {
      "Name": "Next",
      "Validate": [
        {
          "checkType": "atLeastXEntered",
          "validatorid": [1, 2, 3]
        }
      ]
    }
  ]
}
